//import Splide from '@splidejs/splide';

// Import our default css theme for splide
//import '@splidejs/splide/css';

// This should only be output on the frontend of the site - NOT the editor
//console.log("hello from the frontend.")

// document.addEventListener( 'DOMContentLoaded', () => {

//   // Splide
//   const splideCard = document.querySelectorAll('.splideCard')

//   if(!!splideCard && splideCard.length > 0){
//     splideCard.forEach(splideCard => {
//       // Grab the slide interval and convert it to an integer and milliseconds
//       const interval = parseInt(splideCard.dataset.interval) * 1000 || 3000

//       new Splide(splideCard, { pagination: false, perMove: 1, fixedWidth: '420px', fixedHeight: '500px', pauseOnHover: false, interval: interval,
//         // perPage: 2,
//         height: 'auto',
//         gap    : '2rem',
//         // padding: '5rem',
//           breakpoints: {
//             6000: {
//               fixedWidth: '420px', fixedHeight: '500px',
//               gap    : '2rem',
//               //padding: '5rem',
//             },
        
//             2000: {
//               fixedWidth: '420px', fixedHeight: '500px',
//               gap    : '2rem',
//               //padding: '5rem',
          
//             },
        
//             1200: {
//               fixedWidth: '420px', fixedHeight: '500px',
//               gap    : '2rem',
//               //padding: '5rem',
          
//             },
        
//             960: {
//               fixedWidth: '400px', fixedHeight: '500px',
//               gap    : '.7rem',
//               //padding: '0.1rem',
              
//             },
//             400: {
//               fixedWidth: '100%', fixedHeight: '500px',
//               gap    : '1.2rem',
//               //padding: '0.2rem',
        
//               //gap    : '8rem',
        
//             }
//           },
        
        
//               }).mount()

//     })
//   }
// })